module.exports = __webpack_public_path__ + "img/application-icon.a2d9c50b.svg";